import React from "react";
import HeroSection from "./HeroSection/HeroSection";
import AfaziDiscountSection from "./AfaziDiscountSection/AfaziDiscountSection";
import UserTypeSection from "./UserTypeSection/UserTypeSection";
import TrialBox from "./TrialBox/TrialBox";
import StatsSection from "./StatsSection/StatsSection";
import TalepFormu from "./TalepFormu/TalepFormu";

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <AfaziDiscountSection />
      <UserTypeSection />
      <TrialBox/>
      <StatsSection/>
      <TalepFormu/>
    </div>
  );
};

export default HomePage;
